import React from "react";
import CourseLabel from "./CourseLabel"
import Search from "../NavBar/Search";

const styles = {
    container: {
        height: 60,
        width: 240,

        background: "linear-gradient(180deg, #E8E6E3 54.17%, #B6B1A9 100%)",
        boxShadow: "0px 6px 4px rgba(0, 0, 0, 0.25)",
        boxSizing: "border-box",
        border: "5px solid transparent",
        borderTopColor: "#DDDAD5",
        borderLeftColor: "#D1CDC7",
        borderRightColor: "#B6B1A9",
        borderBottomColor: "#A19B91",
        borderRadius: "10px"
    },

    text: {
        position: "inherit",
        bottom: "5px",

        fontFamily: "Chronicle Display",
        fontSize: "14px",
        textIndent: "5px",

        color: "#000000"

    }
};

function CourseBlock(props) {

    return (
        <div style={styles.container}>
            <CourseLabel
                courseCode={props.courseCode}
                fromSearchList={props.fromSearchList}
                addToPlanCoursesList={props.addToPlanCoursesList}
                course={props.course}
            />
            <div style={styles.text}>
                {props.courseName}
            </div>
        </div>
    );
}

export default CourseBlock;